
import React from 'react';

import FSIndex from "@dndComponents/FSIndex";

export default function GameClassIndex() {
  return (
    <FSIndex
      data_type="game_class"
      // log_it
      // quick_fields={["sidekick"]}
    />
  );
}
